/* eslint-disable */
$(document).ready(() => {
  if ($(".sitemenu__hide").length) {
    hide_menu()
  }
})

function hide_menu() {
  const $ccol = $(document)
  $ccol.scroll(() => {
    $ccol.scrollTop() > 20 && $(window).width() > 980
      ? $(".sitemenu")
          .stop()
          .fadeOut()
      : $(".sitemenu")
          .stop()
          .fadeIn()
  })
}

$(document).ready(() => {
  const $overlay = $(".sitemenu-nav__overlay")
  const transEndEventNames = {
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "transitionend",
    OTransition: "oTransitionEnd",
    msTransition: "MSTransitionEnd",
    transition: "transitionend",
  }
  const transEndEventName = transEndEventNames.transition
  let animated = false
  $overlay.find("li").hover(
    function() {
      if ($(".sitemenu-nav__invisible").is(":visible")) {
        $(this)
          .stop()
          .fadeTo(100, 1)
        $(this)
          .siblings()
          .stop()
          .fadeTo(200, 0.3)
      } else {
        $(this)
          .stop()
          .fadeTo(100, 1)
        $(this)
          .siblings()
          .not(".sitemenu-nav__invisible")
          .stop()
          .fadeTo(200, 0.3)
      }
    },
    function() {
      if ($(".sitemenu-nav__invisible").is(":visible")) {
        $(this).stop()
        $(this)
          .siblings()
          .stop()
      } else {
        $(this).stop()
        $(this)
          .siblings()
          .not(".sitemenu-nav__invisible")
          .stop()
      }
    },
  )

  $overlay.find("ul").mouseleave(function() {
    if ($(".sitemenu-nav__invisible").is(":visible")) {
      $(this)
        .children("li")
        .stop()
        .fadeTo(200, 1)
    } else {
      $(this)
        .children("li")
        .not(".sitemenu-nav__invisible")
        .stop()
        .fadeTo(200, 1)
    }
  })

  function toggleOverlay() {
    if ($overlay.hasClass("sitemenu-nav__overlay_open")) {
      $(".move").hide()
      $overlay.removeClass("sitemenu-nav__overlay_open")
      $("body").removeClass("no-scroll")
      $overlay.addClass("sitemenu-nav__overlay_close")

      const onEndTransitionFn = function() {
        $overlay.removeClass("sitemenu-nav__overlay_close")
      }
      $overlay.bind(transEndEventName, onEndTransitionFn)
    } else if (!$overlay.hasClass("sitemenu-nav__overlay_close")) {
      $overlay.addClass("sitemenu-nav__overlay_open")
      $("body").addClass("no-scroll")
      $(".move").show()
    }
  }
  const $button = $(".sitemenu-nav__button")
  $button.on("click", () => {
    if (animated) return
    animated = true
    toggleOverlay()
    if ($button.hasClass("sitemenu-nav__button_open")) {
      $button.removeClass("sitemenu-nav__button_open")
    } else {
      $button.addClass("sitemenu-nav__button_open")
      $button.removeClass("sitemenu-nav__button_modifier")
    }
    setTimeout(() => {
      animated = false
    }, 700)
  })

  $overlay.on("mousewheel", (e) => {
    e.stopPropagation()
  })
})



// WEBPACK FOOTER //
// ./src/blocks/menu/menu.js